import React, { useContext } from 'react';
import { TouchableHighlight, TouchableHighlightProps, View } from 'react-native';
import { ThemeContext } from '../ThemeProvider';

export interface TouchableProps {
  borderRadius?: number;
  children?: any;
  color?: string;
}

export const Touchable = (props: TouchableProps & TouchableHighlightProps) => {
  const theme = useContext(ThemeContext);
  const underlayColor = props.underlayColor || theme.colors.gray.light;

  let viewStyle = {};
  if (props.borderRadius) {
    viewStyle = {
      borderRadius: props.borderRadius,
      overflow: 'hidden',
    };
  }

  return (
    <View style={viewStyle}>
      <TouchableHighlight {...props} underlayColor={underlayColor} />
    </View>
  );
};
